<div class="connection-overlay" [class.hidden]="!isVisible()">
  <div class="overlay-content">
    <div class="icon-container">
      @if (isReconnecting()) {
      <img [src]="currentConfig()?.theme?.connectedIcon || 'assets/connected.svg'" alt="connected"
        style="width: 3.75rem; height: 3.75rem; object-fit: contain" />
      } @else {
      <img [src]="currentConfig()?.theme?.noWifiIcon || 'assets/gse-no-wifi.svg'" alt="No Connection"
        style="width: 3.75rem; height: 3.75rem; object-fit: contain" />
      }
    </div>
    <p class="status-title">
      {{ (isReconnecting() ? 'connectionRestored' : 'connectionLost') | translate }}
    </p>
    <p class="status-description">
      {{ (isReconnecting() ? 'connectionLostDetail' : 'connectionRestoredDetail') | translate }}
    </p>
    <div class="status-indicator">
      @if (!isReconnecting()) {
      <app-spinner size="2.5rem" color="var(--primary-color)"></app-spinner>
      <span class="status-text">{{ 'reConnecting' | translate }}</span>
      } @else {
      <div class="connected-section">
        <img src="assets/connected.svg" alt="connected" style="width: 1rem; height: 1rem; object-fit: contain" />
        <span class="status-connected">{{ 'connected' | translate }}</span>
      </div>
      }
    </div>
  </div>
</div>

<!-- Preloader for connection icons -->
<div class="preloader-icons">
  @for (config of allConfigs(); track config.id) {
  @if (config.theme.noWifiIcon) {
  <img [src]="config.theme.noWifiIcon" alt="preload" />
  }
  @if (config.theme.connectedIcon){
  <img [src]="config.theme.connectedIcon" alt="preload" />
  }
  }
  <img src="assets/connected.svg" alt="preload" />
</div>